module.exports = __webpack_public_path__ + "static/media/phoenix.c4b5025a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/phoenix.svg
// module id = 517
// module chunks = 0